import DeltaCounts from "components/DeltaCounts";
import { isAnsibleStackVendor } from "utils/stack";
import { TableSimpleCellProps } from "ds/components/TableSimple/types";
import { Stack } from "types/generated";
import TableSimpleCell from "ds/components/TableSimple/Cell";
import TableCellEmpty from "ds/components/Table/Row/CellEmpty";

const StacksTableDeltaCell = ({ item: stack, ...cellProps }: TableSimpleCellProps<Stack>) => {
  return (
    <TableSimpleCell {...cellProps}>
      {!stack.delta && <TableCellEmpty />}

      {stack.delta && (
        <DeltaCounts
          size="small"
          align="start"
          variant="flexible"
          direction="column"
          delta={stack.delta}
          isAnsible={isAnsibleStackVendor(stack)}
          responsive
        />
      )}
    </TableSimpleCell>
  );
};

export default StacksTableDeltaCell;
